export type HostlessStreamSourceUrlStatus =
  | "not-hostless"
  | "valid"
  | "invalid-port"
  | "unsupported-type"
  | "bare-port";

const HOSTLESS_SOURCE_TYPES = new Set(["udp", "srt"]);

export const validateHostlessStreamSourceUrl = (
  rawValue: string,
  rawType: string
): HostlessStreamSourceUrlStatus => {
  const value = rawValue.trim();
  const type = rawType.trim().toLowerCase();
  if (!value || !type) {
    return "not-hostless";
  }

  const protocol = `${type}://`;
  if (!value.toLowerCase().startsWith(protocol)) {
    return "not-hostless";
  }

  const address = value.slice(protocol.length);
  if (HOSTLESS_SOURCE_TYPES.has(type) && /^\d+$/.test(address)) {
    return "bare-port";
  }
  if (!address.startsWith(":")) {
    return "not-hostless";
  }
  if (!HOSTLESS_SOURCE_TYPES.has(type)) {
    return "unsupported-type";
  }

  const match = /^:(\d+)$/.exec(address);
  if (!match) {
    return "invalid-port";
  }

  const port = Number(match[1]);
  return port >= 1 && port <= 65535 ? "valid" : "invalid-port";
};
